export default __webpack_public_path__ + "static/carousel-design-e5d973be7dcac5eb5f39b5fa1e2c9125.svg";